import * as R from 'ramda'
import Vue from 'vue'
import { makeCancellable, takeLatest } from 'vuex-cancellable-actions'

import { apiGet, apiPost } from '../api'

export default { // events for chart
  namespaced: true,
  state: {
    // Типы событий с учетом настроек портала
    // {
    //   'email-read': {
    //     code: 'email-read',
    //     name: 'Прочтение письма',
    //     color: '#fff123',
    //     expand: false,
    //     categoryCode: 'main',
    //     sort: 500,
    //     isCustomType: false,  // см. модель CustomEventType
    //   },
    //   ...
    // }
    map: null,
    defaults: null, // Типы событий по умолчанию, такой же shape
  },
  getters: {
    sorted: R.pipe(
      R.prop('map'),
      R.unless(R.isNil, R.pipe(
        R.values,
        R.sortWith([
          R.ascend(R.prop('sort')),
          R.ascend(R.compose(R.toLower, R.prop('name'))),
        ]),
      )),
    ),
  },
  mutations: {
    setMap: (state, { eventTypes }) => {
      state.map = eventTypes
    },
    update: (state, { eventType }) => {
      if (!state.map) { throw new Error('no event types loaded') }
      Vue.set(state.map, eventType.code, eventType)
    },
    remove: (state, { code }) => {
      if (!state.map) { throw new Error('no event types loaded') }
      Vue.delete(state.map, code)
    },
    updateSort: (state, { sortMap }) => { // sortMap: { 'email-read': 10, ... }
      if (!state.map) { throw new Error('no event types loaded') }
      Object.entries(sortMap)
        .forEach(([code, sort]) => {
          Vue.set(state.map[code], 'sort', sort)
        })
    },
    setDefaults: (state, { defaultEventTypes }) => {
      state.defaults = defaultEventTypes
    },
  },
  actions: makeCancellable({
    get: takeLatest((
      { state, rootState, commit, dispatch },
      { reload = false } = {},
    ) =>
      !reload && state.map !== null
        ? Promise.resolve()
        : apiGet({ url: `/api/event-type/get/`, rootState, dispatch })
          .then(({ res: eventTypes }) => commit('setMap', { eventTypes }))
    ),
    getDefaults: takeLatest((
      { state, rootState, commit, dispatch },
      { reload = false } = {},
    ) =>
      !reload && state.defaults !== null
        ? Promise.resolve()
        : apiGet({ url: `/api/event-type/get-defaults/`, rootState, dispatch })
          .then(({ res: defaultEventTypes }) =>
            commit('setDefaults', { defaultEventTypes }))
    ),
    reorder: takeLatest((
      { rootState, commit, dispatch },
      { codes },
    ) =>
      apiPost({
        rootState,
        dispatch,
        url: `/api/event-type/reorder/`,
        data: { codes },
      })
        .then(({ res: sortMap }) =>
          commit('updateSort', { sortMap }))
    ),
    set: takeLatest((
      { rootState, commit, dispatch },
      { eventType: { code, name, color, expand, categoryCode } },
    ) =>
      apiPost({
        rootState,
        dispatch,
        url: `/api/event-type/set/`,
        data: { code, name, color, expand, categoryCode },
      })
        .then(({ res: eventType }) =>
          commit('update', { eventType }))
    ),
    remove: (
      { rootState, commit, dispatch },
      { code },
    ) =>
      apiPost({
        rootState,
        dispatch,
        url: `/api/event-type/remove/`,
        data: { code },
      })
        .then(() => commit('remove', { code })),
  }),
}
